export default __webpack_public_path__ + "static/moreton-card-b841965318ad198542d7941aac4be1b8.jpg";